import React, { ReactNode } from 'react';
import './DataSourcePage.css';
import { Link, Outlet } from 'react-router-dom';

interface DataSourcePageProps {
    rightContent?: ReactNode;
}

const DataSourcePage: React.FC<DataSourcePageProps> = () => {
    return (
        <div className="data-source-page">
            <div className="data-source-container">
                <div className="data-source-sidebar">
                    <h2>Data Source</h2>
                    <ul>
                        <li>
                            <Link to="/data-source/add-new-connection" className="link">
                                Config Data Source
                            </Link>
                        </li>
                        {/*<li>*/}
                        {/*    <Link to="/data-source/data-sources-list" className="link">*/}
                        {/*        Data sources*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                    </ul>
                </div>
                <div className="data-source-main-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default DataSourcePage;
